// extracted by mini-css-extract-plugin
export default {"activedfdf":"Navbar_activedfdf__nYXkq","active":"Navbar_active__yvYVY"};